import { Ellipsis } from '@zoom/components';
import classnames from 'classnames';
import { pipe, countBy, map } from 'ramda';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AdherenceEventType, AdherenceReasonCode } from '../../graphql/components';

type ACDStatusLabelProps = {
  className?: string;
  eventType: AdherenceEventType;
  reasonCode?: AdherenceReasonCode;
  showSource?: boolean;
};

export const composeReasonCodeUniqueKey = (reasonCode: AdherenceReasonCode) =>
  `${reasonCode.eventType}-${reasonCode.label.replace(/\s/g, '_')}-${reasonCode.code}`;

export const getDuplicatedReasonCodes = pipe(
  countBy(composeReasonCodeUniqueKey),
  // Need to be specific with typings, see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/38173
  map<{ [reasonCodeUniqueKey: string]: number }, { [reasonCodeUniqueKey: string]: boolean }>(
    (count: number) => count > 1
  )
);

export const ACDStatusLabel: React.FC<ACDStatusLabelProps> = ({
  className,
  eventType,
  reasonCode,
  showSource = false,
}) => {
  const { t } = useTranslation();
  let title = eventType.eventName;

  if (reasonCode) {
    title += ` - ${reasonCode.label}`;
  }

  return (
    <div className={classnames('acd-status-label', className)}>
      <span className="acd-status-label__title">
        {/* @ts-expect-error: Incompatible type of FC from React < v18 */}
        <Ellipsis>{title}</Ellipsis>
      </span>
      {reasonCode && (
        <>
          {showSource && (
            <span className="acd-status-label__detail">
              {t('scheduleAdherence.source')}: <span className="font-weight-bold">{reasonCode.sourceId}</span>
            </span>
          )}
          <span className="acd-status-label__detail">
            {t('scheduleAdherence.reasonCode')}: <span className="font-weight-bold">{reasonCode.code}</span>
          </span>
        </>
      )}
    </div>
  );
};
